type PropsType = {
  message: string;
  type: "success" | "error" | "loading";
};

export const Overlay = ({ message, type }: PropsType) => {
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50">
      {type === "success" && (
        <div className="bg-white p-4 rounded-md">
          <h2 className="text-2xl font-bold">{message}</h2>
        </div>
      )}
      {type === "error" && (
        <div className="bg-white p-4 rounded-md">
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
            <span className="block sm:inline">{message}</span>
          </div>
        </div>
      )}
      {type === "loading" && (
        <div className="bg-white p-4 rounded-md flex flex-col items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          <h2 className="text-2xl font-bold">{message}</h2>
        </div>
      )}
    </div>
  );
};
